import { z } from 'zod';

import type { OneInchNetwork, OneInchToken } from '@shared/api/types/magicSwap';

enum SwapOperationType {
  SingleChain = 'SINGLE_CHAIN',
  CrossChain = 'CROSS_CHAIN',
}

enum SwapOperationStatus {
  Pending = 'PENDING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Unknown = 'UNKNOWN',
}

const SwapOperationSideSchema = z.object({
  network: z.any().refine<OneInchNetwork>((value: unknown): value is OneInchNetwork => true),
  token: z
    .any()
    .refine<OneInchToken>((value: unknown): value is OneInchToken => true)
    .nullable(),
  amount: z.bigint(),
});

type SwapOperationSide = z.infer<typeof SwapOperationSideSchema>;

const SwapOperationSpecificationSchema = z.object({
  source: SwapOperationSideSchema,
  destination: SwapOperationSideSchema,
  slippagePercent: z.number(),
});

type SwapOperationSpecification = z.infer<typeof SwapOperationSpecificationSchema>;

export {
  SwapOperationSideSchema,
  type SwapOperationSide,
  SwapOperationSpecificationSchema,
  type SwapOperationSpecification,
  SwapOperationType,
  SwapOperationStatus,
};
